<template>
    <nav class="navbar navbar-expand-sm navbar-light py-3 px-2">
        <router-link class="navbar-brand" to="/">
            Gradient Magic
            <!-- Gradient <span class="magic">Magic</span> -->
        </router-link>
        <button @click="toggleNav()" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="navbar-collapse" :class="{'collapse': navCollapsed}" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item mr-3 dropdown d-sm-none d-md-inline" @click.stop="showCategoryDropdown = !showCategoryDropdown">
                    <a class="nav-link dropdown-toggle cursor-pointer">
                        <span class="d-none d-md-inline">Select a</span> Category
                    </a>
                    <div class="dropdown-menu" v-show="showCategoryDropdown" style="display: block;">
                        <router-link
                            v-for="category in categories"
                            :key="category.name"
                            class="dropdown-item"
                            :to="{name: 'category', params: {cat: category.id}}"
                        >
                            {{category.name}}
                        </router-link>
                    </div>
                </li>
                <li class="nav-item mr-3">
                    <router-link class="nav-link" to="/browse">
                        <span class="d-none d-md-inline">All</span> Collections
                    </router-link>
                </li>
                <!-- <li class="nav-item mr-3 d-none d-lg-block">
                    <a class="nav-link cursor-pointer" @click="gotoRandomCollection">Random</a>
                </li> -->
                <li class="nav-item mr-4">
                    <router-link class="nav-link" to="/about">About</router-link>
                </li>
                <li class="nav-item">
                    <router-link to="/premium" class="nav-link btn btn-cta px-3">
                        Premium <span class="d-none d-lg-inline">Gradients</span>
                    </router-link>
                </li>

            </ul>
        </div>
    </nav>
</template>

<script>
import collections from '@/util/collections.js'
import categories from '@/util/categories.js'

function randomElement(arr){
  return arr[Math.floor(Math.random()*arr.length)];
}

export default {
    data(){
        return {
            showCategoryDropdown: false,
            navCollapsed: true
        }
    },
    methods: {
        toggleNav(){
            this.navCollapsed = !this.navCollapsed;
        },
        gotoRandomCollection(){
            let randomCollection = randomElement(collections);
            this.$router.push({ name: 'collection', params: {cid: randomCollection.id}});
        },
        closeDropdown(){
            this.showCategoryDropdown = false;
        }
    },
    computed: {
        categories(){
            return categories;
        }
    },
    created(){
        window.addEventListener('click', this.closeDropdown)
    },
    beforeDestroy(){
        window.removeEventListener('click', this.closeDropdown)
    }  
}
</script>

<style lang="scss">
.navbar {
    $dark: #343a40;
    &.navbar-light .navbar-nav .nav-link {
        color: $dark;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .navbar-brand {
        font-weight: bold;
        font-size: 1.4rem;
    }
    // .magic {
    //     font-weight: bold;

    //     color: transparent;
    //     background-clip: text;
    //     -webkit-background-clip: text;
    //     // Rainbow from original page.
    //     background-image: linear-gradient(45deg,#51ea5b 0,#51eace 12%,#5193ea 39%,#8251ea 49%,#ea51e0 73%,#ea516d 81%,#eaa851 90%,#baea51 100%);
    // }
}

</style>